import { DashboardLayout } from "../components/DashboardLayout";
import { FinanceAdvisor } from "../components/FinanceAdvisor";

export default function FinanceAdvisorPage() {
  return (
    <DashboardLayout title="Finance Advisor">
      <div className="space-y-4" data-testid="finance-advisor-page">
        <p className="text-sm text-muted-foreground max-w-2xl">
          Deep P&amp;L, tax and take-home analysis — powered by your live invoices, expenses,
          supplier bills and settings. Toggle between company and sole-trader tax treatment.
        </p>
        <FinanceAdvisor />
      </div>
    </DashboardLayout>
  );
}
